import type { OverrideField } from './types';

export const OVERRIDE_FIELDS: Array<OverrideField> = [];
